"use client";

import { c as _c } from "react/compiler-runtime";
import { ReactNode } from "react";
import BaseLink from "../../base-link/base-link";
import { PortableText } from "next-sanity";
import InternalLink from "@/components/common/internal-link";
import type { RichTableCell as RichTableCellType } from "@/sanity/sanity.types";
import { sanitizeLinkSpans } from "@/utilities/sanitizeLinkSpans";
export interface IMarkProps {
  children?: ReactNode;
  value?: any;
}
export type CellValue = RichTableCellType & {
  _key?: string;
};
const cellComponents = {
  types: {
    undefined: () => null
  },
  list: {
    bullet: ({
      children
    }: {
      children?: ReactNode;
    }) => <ul className="ml-5 list-disc">{children}</ul>,
    number: ({
      children
    }: {
      children?: ReactNode;
    }) => <ol className="ml-5 list-decimal">{children}</ol>
  },
  marks: {
    unknownMark: () => null,
    link: ({
      children,
      value
    }: IMarkProps) => <BaseLink href={value?.href || "#"} target={value?.blank ? "_blank" : undefined} rel={value?.blank ? "noopener noreferrer" : undefined} className="underline">
        {children}
      </BaseLink>,
    internalLink: ({
      children,
      value
    }: IMarkProps) => <InternalLink value={value}>{children}</InternalLink>
  }
};
const RichTableCell = t0 => {
  const $ = _c(4);
  const {
    cell
  } = t0;
  if (!cell?.content?.length) {
    return null;
  }
  let t1;
  if ($[0] !== cell.content) {
    t1 = sanitizeLinkSpans(cell.content);
    $[0] = cell.content;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <PortableText value={t1} components={cellComponents} onMissingComponent={_temp} />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default RichTableCell;
function _temp() {
  return null;
}